module.exports = __webpack_public_path__ + "static/media/OutliersQ5_1.b11a592d.svg";